import { makeAutoObservable, runInAction } from 'mobx';

import { CourierQuote } from "../../../Common/DTOs/Delivery/CourierShipmentResponseModel";
import { addressAjaxController } from "../../../Common/Ajax/AddressAjaxController";
import { ValidationResponse } from "../../../Common/DTOs/ValidationResponse";
import { addressesController } from '../../../Common/Controllers/AddressesController';
import { alertController } from '../../../Common/Controllers/AlertController';
import { CourierShipmentQuoteRequest, PackageIssue } from '../../../Common/DTOs/Delivery/CourierShipmentQuoteRequest';
import { basketController } from '../../../Common/Controllers/BasketController';
import { stockistCourierShipmentAjaxController } from '../../../Common/Ajax/StockistCourierShipmentAjaxController';
import { countryController } from '../../../Common/Controllers/CountryController';

export class DeliveryDetailsController {
  validationInProgress = false;
  validationResult: ValidationResponse | null = null;
  deliveryOptions: CourierQuote[] = [];
  isDeliveryOptionsLoading = false;

  checkDeliveryDetailsCorrect = async () => {
    this.validationInProgress = true;
    const address = addressesController.selectedDeliveryAddress;
    if (!address) {
      alertController.displayAlert("Please select a delivery address before proceeding", [], "error");
      return;
    }
    const validationResult = await addressAjaxController.validateAddress(address);

    runInAction(() => this.validationInProgress = false);
    return validationResult;
  }

  getDeliveryOptions = async () => {
    if (!addressesController.selectedDeliveryAddress || !basketController.basket || basketController.basket.purchasableItems.length == 0 || this.isDeliveryOptionsLoading) return;
    this.isDeliveryOptionsLoading = true;

    const selectedAddress = addressesController.selectedDeliveryAddress;
    const countryObj = countryController.countries.find(c => c.name === selectedAddress.country);
    const countryIso = countryObj ? countryObj.iso_a2 : selectedAddress.country;
    const getQuotesRequest = {
      country: countryIso,
      postalCode: addressesController.selectedDeliveryAddress.postCode,
      issues: basketController.basket.purchasableItems.map(item => ({
        issueId: item.issueId,
        magazineId: item.magazineId,
        quantity: item.totalOrderQuantity,
        unitPrice: item.issuePrice,
        singleIssueThicknessMM: item.issue.thicknessInMM,
        singleIssueWeight: item.issue.weight,
        issueName: item.issue.identity,
        magazineTitle: item.issue.magazine.title,
      } as PackageIssue))
    } as CourierShipmentQuoteRequest

    try {
      const res = await stockistCourierShipmentAjaxController.getQuotes(getQuotesRequest);

      if (res.errorMessages && res.errorMessages.length > 0) {
        alertController.displayAlert("Error", res.errorMessages.join("\n"), "error", 4500);
      }
      runInAction(() => this.deliveryOptions = res.quotes);
    } finally {
      runInAction(() => this.isDeliveryOptionsLoading = false);
    }
  }

  constructor() {
    makeAutoObservable(this);
  }
}

export const deliveryDetailsController = new DeliveryDetailsController()